<template>
  <el-dialog v-loading="isLoading" :title="title" append-to-body :visible.sync="mIsShow">

    <el-form :model="form" label-width="80px" @submit.native.prevent style="max-width: 1030px;">
      <el-form-item label="姓名">
        <el-input v-model="form.Profile.Name"></el-input>
      </el-form-item>
      <el-form-item label="階級">
        <el-select v-model="form.AdminLevel" placeholder="請選擇">
          <el-option :value="0" label="一般會員"></el-option>
          <el-option :value="10" label="部落客"></el-option>
          <el-option :value="100" label="會計"></el-option>
          <el-option :value="1000" label="管理員"></el-option>
          <el-option :value="10000" label="最高管理員"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="form.AdminLevel==10" label="ID">
        <el-input v-show="form.AdminLevel==10" v-model="form.Profile.URLKey" :disabled="!IDEditable"></el-input>
        <p class="hint">部落客專屬ID，用於團購網址。ex: /team-buying/XXXXX-XXXXX。設置後不可編輯</p>
      </el-form-item>
      <el-form-item label="電話">
        <el-input v-model="form.Profile.Phone"></el-input>
      </el-form-item>
      <el-form-item label="出生年">
        <el-input v-model="form.Profile.BirthYear"></el-input>
      </el-form-item>
      <el-form-item label="出生月">
        <el-input v-model="form.Profile.BirthMonth"></el-input>
      </el-form-item>
      <el-form-item label="出生日">
        <el-input v-model="form.Profile.BirthDay"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="submit">送出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
export default {
  mixins: [MixinOfPreventLeaveEditPage],
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    oriObj: {
      default: () => {
        return null
      }
    }
  },
  data () {
    return {
      form: {
        Profile: {}
      },
      mIsShow: false,
      isLoading: false,
      IDEditable: false
    }
  },
  computed: {
    isEdit () {
      return true
    },
    title () {
      return '編輯使用者 ' + (this.oriObj || { Profile: {} }).Profile.Name
    },
    userID () {
      return this.oriObj.ID
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    submit () {
      if (!this.validateInput()) {
        return
      }
      this.form.Profile.BirthYear = parseInt(this.form.Profile.BirthYear)
      this.form.Profile.BirthMonth = parseInt(this.form.Profile.BirthMonth)
      this.form.Profile.BirthDay = parseInt(this.form.Profile.BirthDay)
      let payload = JSON.parse(JSON.stringify(this.form))
      if (!this.isEdit) throw String('unexpected add user in [modal-editor-profile]')
      let promise = this.isEdit
        ? this.$services.user.edit(this, this.userID, { user: payload })
        : this.$services.user.add(this, this.form)
      promise.then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) this.onObjAddedit(res, payload)
      }).catch(this.$handleServiceError)
    },
    onObjAddedit (res, payload) {
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = { Profile: {} }
      this.$emit('submitted', payload)
      this.close()
    },
    loadResult (res) {
      var newObj = JSON.parse(JSON.stringify(this.form.Profile))
      if (!this.isEdit) {
        this.$store.state.user.list.splice(0, 0, newObj)
      } else {
        let oldProfile = JSON.parse(JSON.stringify(this.oriObj.Profile))
        let newProfile = Object.assign(oldProfile, newObj)
        let idx = this.$store.state.user.list.findIndex(
          o => o.ID === this.userID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.user.list[idx], 'Profile', newProfile)
        } else {
          console.error(`unknown user for id ${this.userID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null
      // if (!this.form.TitleTw) {
      //   errMsg = '請輸入繁中標籤'
      // }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    }
  },
  created () {
    this.mIsShow = this.isShow
  },
  watch: {
    isShow () {
      this.mIsShow = this.isShow
    },
    mIsShow () {
      if (!this.mIsShow) this.close()
      else {
        if (this.oriObj) {
          // this.form = { Profile: JSON.parse(JSON.stringify(this.oriObj.Profile)) }
          this.form = JSON.parse(JSON.stringify(this.oriObj))
          this.IDEditable = !this.form.Profile.URLKey
        } else {
          this.form = {
            Profile: {}
          }
        }
      }
    }
  }
}
</script>
